'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lio_intela_sites_digitalinternship_data_Segments$UseCasesSection(eyebrow, title, cards) {
  this.iN = null;
  this.iO = null;
  this.iM = null;
  this.iN = eyebrow;
  this.iO = title;
  this.iM = cards;
}
export { $c_Lio_intela_sites_digitalinternship_data_Segments$UseCasesSection as $c_Lio_intela_sites_digitalinternship_data_Segments$UseCasesSection };
$p = $c_Lio_intela_sites_digitalinternship_data_Segments$UseCasesSection.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lio_intela_sites_digitalinternship_data_Segments$UseCasesSection;
/** @constructor */
function $h_Lio_intela_sites_digitalinternship_data_Segments$UseCasesSection() {
}
export { $h_Lio_intela_sites_digitalinternship_data_Segments$UseCasesSection as $h_Lio_intela_sites_digitalinternship_data_Segments$UseCasesSection };
$h_Lio_intela_sites_digitalinternship_data_Segments$UseCasesSection.prototype = $p;
$p.N = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.s = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().W(this, 1424051777, true);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lio_intela_sites_digitalinternship_data_Segments$UseCasesSection)) {
    if (((this.iN === x$0.iN) && (this.iO === x$0.iO))) {
      var x = this.iM;
      var x$2 = x$0.iM;
      return ((x === null) ? (x$2 === null) : x.i(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.t = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().V(this);
});
$p.G = (function() {
  return 3;
});
$p.I = (function() {
  return "UseCasesSection";
});
$p.H = (function(n) {
  switch (n) {
    case 0: {
      return this.iN;
      break;
    }
    case 1: {
      return this.iO;
      break;
    }
    case 2: {
      return this.iM;
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lio_intela_sites_digitalinternship_data_Segments$UseCasesSection(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.bO)));
}
export { $isArrayOf_Lio_intela_sites_digitalinternship_data_Segments$UseCasesSection as $isArrayOf_Lio_intela_sites_digitalinternship_data_Segments$UseCasesSection };
var $d_Lio_intela_sites_digitalinternship_data_Segments$UseCasesSection = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lio_intela_sites_digitalinternship_data_Segments$UseCasesSection, "io.intela.sites.digitalinternship.data.Segments$UseCasesSection", ({
  bO: 1,
  b: 1,
  e: 1,
  a: 1
}));
export { $d_Lio_intela_sites_digitalinternship_data_Segments$UseCasesSection as $d_Lio_intela_sites_digitalinternship_data_Segments$UseCasesSection };
//# sourceMappingURL=io.intela.sites.digitalinternship.data.-Segments$-Use-Cases-Section.js.map
